import * as yup from 'yup';

export const initialValues = {
  reassignType: '',
  reassignTo: null,
  reason: '',
};

export const validationSchema = yup.object().shape({
  reassignType: yup.string().required('Reassign Type is required'),
  reassignTo: yup.object().shape({
    value: yup.string().required('Reassign To is required'),
    label: yup.string().required('Reassign To is required'),
  }),
  reason: yup.string().required('Reason is required'),
});

export const reassignTypeOptions = [
  { label: 'Primary Approver', value: 'P' },
  { label: 'Secondary Approver', value: 'S' },
];
